<script>
  import Footer from '../components/Footer.svelte';
  import Header from '../components/Header.svelte';
  import { topicsData } from '../data/topics.js';

  export let slug = 'ai-cases';

  $: topic = topicsData[slug] ?? topicsData['ai-cases'];

  import { goBack } from '../utils/router.js';
</script>

<div id="top" class="topic-page">
  <Header />

  <main class="topic-main">
    <div class="topic-shell">
      <button class="back-link" type="button" on:click={goBack}>
        <span class="back-icon" aria-hidden="true"></span>
        <span>Назад</span>
      </button>

      <section class="topic-content" aria-labelledby="topic-title">
        <div class="topic-heading">
          <h1 id="topic-title">{topic.title}</h1>
          <p>{topic.subtitle}</p>
        </div>

        <article class="topic-card">
          {#if topic.iconSrc}
            <img class="topic-icon" src={topic.iconSrc} alt="" aria-hidden="true" />
          {/if}
          <div class="topic-copy">
            {#if topic.description}
              <p>{topic.description}</p>
            {/if}
            {#if topic.bullets && topic.bullets.length}
              <ul class="topic-bullets">
                {#each topic.bullets as bullet}
                  {#if typeof bullet === 'string'}
                    <li>{bullet}</li>
                  {:else}
                    <li>
                      <strong>{bullet.title}</strong>
                      {#if bullet.items && bullet.items.length}
                        <ul>
                          {#each bullet.items as item}
                            <li>{item}</li>
                          {/each}
                        </ul>
                      {/if}
                    </li>
                  {/if}
                {/each}
              </ul>
            {/if}
          </div>
        </article>

        {#if topic.speaker}
          <article class="speaker-card {topic.speaker.imageSrc ? '' : 'speaker-card--no-photo'}" aria-label="Спикер темы">
            {#if topic.speaker.imageSrc}
              <span class="speaker-photo-frame">
                <img
                  class="speaker-photo"
                  src={topic.speaker.imageSrc}
                  alt={topic.speaker.name}
                  style={`--image-width: ${topic.speaker.imageWidth ?? '100%'}; --image-height: ${topic.speaker.imageHeight ?? '100%'}; --image-left: ${topic.speaker.imageLeft ?? '0'}; --image-top: ${topic.speaker.imageTop ?? '0'}`}
                />
              </span>
            {/if}
            <div class="speaker-copy">
              <h2>{topic.speaker.name}</h2>
              <p class="speaker-role">{topic.speaker.role}</p>
              {#if Array.isArray(topic.speaker.company)}
                {#each topic.speaker.company as line}
                  <p class="speaker-company">{line}</p>
                {/each}
              {:else}
                <p class="speaker-company">{topic.speaker.company}</p>
              {/if}
            </div>
          </article>
        {/if}
      </section>
    </div>
  </main>

  <Footer />
</div>

<style>
  .topic-page {
    min-height: 100vh;
    background: #000000;
    color: #ffffff;
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-variation-settings: 'wdth' 100;
  }

  .topic-main {
    display: flex;
    justify-content: center;
    overflow: hidden;
    padding: 100px 0 100px;
  }

  .topic-shell {
    display: flex;
    width: min(100%, 1440px);
    flex-direction: column;
    gap: 40px;
    padding: 0 128px;
    box-sizing: border-box;
  }

  .back-link {
    display: inline-flex;
    width: fit-content;
    min-height: 40px;
    align-items: center;
    gap: 12px;
    margin: 0;
    padding: 6px 0;
    border: 0;
    background: transparent;
    color: inherit;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.4;
    cursor: pointer;
  }

  .back-link:hover,
  .back-link:focus-visible {
    color: #e7b962;
  }

  .back-icon {
    display: inline-block;
    width: 7px;
    height: 14px;
    background: currentColor;
    -webkit-mask: url('/icons/ui-icon-chevron-right.svg') center / contain no-repeat;
    mask: url('/icons/ui-icon-chevron-right.svg') center / contain no-repeat;
    transform: rotate(180deg);
  }

  .topic-content {
    display: flex;
    flex-direction: column;
    gap: 48px;
  }

  .topic-heading {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  h1,
  h2,
  p {
    margin: 0;
  }

  h1 {
    font-size: 56px;
    font-weight: 700;
    line-height: 56px;
  }

  .topic-heading p {
    max-width: 900px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 32px;
    font-weight: 400;
    line-height: 36px;
  }

  .topic-card {
    display: flex;
    gap: 48px;
    align-items: flex-start;
    padding: 40px 30px;
    border: 2px solid #ffa800;
    border-radius: 16px;
    background: rgba(0, 0, 0, 0.72);
    box-sizing: border-box;
  }

  .topic-copy {
    display: flex;
    flex: 1 1 auto;
    min-width: 0;
    flex-direction: column;
    gap: 28px;
  }

  .topic-bullets {
    margin: 0;
    padding-left: 1.25em;
    list-style: none;
    color: #ffffff;
    font-size: 22px;
    line-height: 32px;
  }

  .topic-bullets > li {
    position: relative;
    padding-left: 4px;
    margin-bottom: 12px;
  }

  .topic-bullets > li::before {
    content: '◆';
    position: absolute;
    left: -1.25em;
    color: #e7b962;
    font-size: 14px;
    line-height: 32px;
  }

  .topic-bullets ul {
    margin: 8px 0 0;
    padding-left: 1.25em;
    list-style: disc;
  }

  .topic-bullets ul li {
    margin-bottom: 4px;
    color: rgba(255, 255, 255, 0.85);
    font-size: 18px;
    line-height: 28px;
  }

  .topic-bullets ul li::marker {
    color: #e7b962;
  }

  .topic-icon {
    width: 109.609px;
    height: 110px;
    flex: 0 0 auto;
  }

  .topic-copy p {
    max-width: 960px;
    color: #ffffff;
    font-size: 22px;
    font-weight: 400;
    line-height: 32px;
  }

  .speaker-card {
    display: flex;
    width: fit-content;
    align-items: center;
    gap: 24px;
  }

  .speaker-card--no-photo {
    align-items: flex-start;
  }

  .speaker-photo-frame {
    position: relative;
    width: 96px;
    height: 96px;
    flex: 0 0 96px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 18px;
    box-sizing: border-box;
  }

  .speaker-photo {
    position: absolute;
    top: var(--image-top);
    left: var(--image-left);
    width: var(--image-width);
    height: var(--image-height);
    max-width: none;
    border-radius: 18px;
    object-fit: cover;
  }

  .speaker-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }

  h2 {
    font-size: 27px;
    font-weight: 500;
    line-height: 34px;
  }

  .speaker-role {
    font-size: 12.4px;
    font-weight: 700;
    line-height: 18.6px;
    letter-spacing: 1.24px;
    text-transform: uppercase;
  }

  .speaker-company {
    color: #e7b962;
    font-size: 15.8px;
    font-weight: 300;
    line-height: 21.7px;
  }

  @media (max-width: 1279px) {
    .topic-main {
      padding: 100px 0;
    }

    .topic-shell {
      gap: 40px;
      padding: 0 32px;
    }

    .topic-content {
      gap: 48px;
    }

    .topic-card {
      flex-direction: column;
      gap: 48px;
    }

    .topic-copy p {
      max-width: none;
      font-size: 20px;
      line-height: 28px;
    }

    h1 {
      font-size: 40px;
      line-height: 1.1;
    }

    .topic-heading p {
      font-size: 22px;
      line-height: 1.3;
    }
  }

  @media (max-width: 1599px) and (min-width: 1280px) {
    h1 {
      font-size: 48px;
      line-height: 1.1;
    }

    .topic-heading p {
      font-size: 26px;
      line-height: 1.3;
    }
  }

  @media (max-width: 767px) {
    .topic-main {
      padding: 100px 0 40px;
    }

    .topic-shell {
      gap: 24px;
      padding: 0 24px;
    }

    .topic-content {
      gap: 24px;
    }

    .topic-heading {
      gap: 24px;
    }

    h1 {
      font-size: 32px;
      line-height: 32px;
    }

    .topic-heading p {
      font-size: 18px;
      line-height: normal;
    }

    .topic-card {
      gap: 24px;
      padding: 24px 16px;
    }

    .topic-icon {
      width: 55.799px;
      height: 56px;
    }

    .topic-copy p {
      font-size: 18px;
      line-height: 24px;
    }

    .speaker-card {
      width: 100%;
      gap: 24px;
    }

    .speaker-photo-frame {
      width: 80px;
      height: 80px;
      flex-basis: 80px;
    }

    h2 {
      font-size: 18px;
      line-height: normal;
    }

    .speaker-role,
    .speaker-company {
      font-size: 14px;
      line-height: normal;
      letter-spacing: 0;
    }
  }
</style>
